module.exports = __webpack_public_path__ + "static/media/expo2020.9ebbc4b6.png";